import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) { }

  //give telecom universal access
  canActivate(route: ActivatedRouteSnapshot): Promise<boolean>|boolean {
    return new Promise(async (resolve) => {
      if (!this.auth.authenticated) {
        await this.auth.isAuthenticated();
      }
      this.auth.getAuthorization().then((res: any) => {
        localStorage.setItem('memberOf', res);
        if (!res && res.StatusCode !== 200) {
          console.error('Error invoking authorizer Lambda');
          resolve(false);
        } else {
          let requiredMemberOf = route.data.requiredMemberOf;
          let authPayload = JSON.parse(res.Payload);
          localStorage.setItem('memberOf', authPayload.authz_result);
          const memberof = authPayload.authz_result;
          if (memberof) {
            this.auth.memberOf = localStorage.getItem('memberOf').split(',');
          }
          let permission: boolean = false;
          if(authPayload.authz_result.includes(environment.roles.telecom)){
            permission = true;
          }else{
            requiredMemberOf.map(role => {
              if (authPayload.authz_result.includes(role)) {
                permission = true;
              }
            });
          }
          if (authPayload.authn_result === 'success' && permission) {
            resolve(true);
          } else if(authPayload.authn_result === 'success' && requiredMemberOf == 'bui') {
            this.router.navigate(['login']);
          } else {
            this.router.navigate(['home'], { queryParams: { authorized: false }});
            resolve(false);
          }
        }
      });
    });
  }
}
